
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/about/membership/join-a-committee",
      function () {
        return require("private-next-pages/about/membership/join-a-committee.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/about/membership/join-a-committee"])
      });
    }
  